import numeral from "numeral";
import moment from "moment";

export default {
  /*
   *  Formatear montos
   *
   *  @param Number
   *  @return String
   */
  currency(val) {
    return numeral(val)
      .format("$0,0")
      .replace(/[,]/g, ".");
  },
  /*
   *  Formatear Fecha
   *
   *  @param Date
   *  @return String
   */
  formatDate(val) {
    if (!moment(val).isValid()) return "Fecha inválida";
    return moment(val).format("MMM Do YY");
  },
  formatDateTime(val) {
    if (!moment(val).isValid()) return "Fecha inválida";
    return moment(val)
      .format("MMMM Do YYYY, h:mm:ss a")
      .toLowerCase()
      .replace("am", "AM")
      .replace("pm", "PM")
      .replace("º", ",");
  },
  ID() {
    /*
     *
     * Example returns _1791563763479179
     *
     */
    return (
      new Date().getHours().toString() +
      new Date().getMinutes().toString() +
      new Date().getUTCMilliseconds().toString()
    ).toString();
  },
  jsonToQueryString(obj) {
    if (!obj) return "";

    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return "?" + str.join("&");
  },
  UUID() {
    // NOTE: This format of 8 chars, followed by 3 groups of 4 chars, followed by 12 chars
    //       is known as a UUID and is defined in RFC4122 and is a standard for generating unique IDs.
    //       This function DOES NOT implement this standard. It simply outputs a string
    //       that looks similar. The standard is found here: https://www.ietf.org/rfc/rfc4122.txt
    //Example Output: "e27881c4-f924-b8f7-59d9-525878c7a812"
    function chr4() {
      return Math.random()
        .toString(16)
        .slice(-4);
    }
    return (
      chr4() +
      chr4() +
      "-" +
      chr4() +
      "-" +
      chr4() +
      "-" +
      chr4() +
      "-" +
      chr4() +
      chr4() +
      chr4()
    );
  },
  /*
   *  Comparar dos strings
   *
   *  @params String
   *  @return Bollean
   */
  compareStrings(a, b) {
    if (!a || !b)
      return false;
      
    return a.toString().trim().toLowerCase() === b.toString().trim().toLowerCase();
  },
  checkCookieExp(dealerIdentifier) {

    const today = new moment();
    const COOKIE_NAME = "blocking-queue-starttime-" + dealerIdentifier;
    let storage = localStorage.getItem(COOKIE_NAME)
            
    if (!storage)
        return false

    storage = JSON.parse(storage);

    let { timeOfBlocking, identifier } = storage;

    // si no es el mismo dealer
    if (!this.compareStrings(dealerIdentifier, identifier))
        return false;
    
    // si no es una fecha válida
    if (!moment(timeOfBlocking).isValid())
        return false;

    // convertir en moment() data;
    timeOfBlocking = new moment(timeOfBlocking);

    // comprobar si el bloqueo de publicaciones se hizo hace mas de: 60minutos
    return  moment.duration(today.diff(timeOfBlocking)).as('minutes') > 60;
  },
  setCookieExp(dealerIdentifier) {
    
    const COOKIE_NAME = "blocking-queue-starttime-" + dealerIdentifier;

    localStorage.setItem(
      COOKIE_NAME, JSON.stringify({ 
          identifier: dealerIdentifier,
          timeOfBlocking: moment().format()
      })
    );
  }
};
